import React from 'react';
import styled from 'styled-components';
import PterodactylPanel from '../PterodactylPanel';

function PterodactylApp() {
  return (
    <PterodactylSection>
      <PterodactylPanel />
    </PterodactylSection>
  );
}

const PterodactylSection = styled.section`
  h2 {
    margin-top: 0;
    color: var(--text-primary);
  }
`;

export default PterodactylApp;
